function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { useState } from 'react';
import * as PropTypes from 'prop-types';
import { Icon, mergeStyleSets } from '@fluentui/react';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
const featuredAppsStyles = mergeStyleSets({
    section: {
        padding: '8px',
        '& .spza_filteredTileContainer': {
            margin: 0,
            paddingBottom: '0px'
        },
        '@media (max-width: 768px)': {
            padding: '15px'
        }
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '12px'
    },
    title: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#333',
        margin: 0,
        marginRight: '8px',
        '@media (max-width: 768px)': {
            fontSize: '16px'
        }
    },
    chevron: {
        fontSize: '12px',
        color: '#666',
        transition: 'transform 0.2s ease'
    },
    content: {
        transition: 'all 0.3s ease',
        overflow: 'hidden'
    },
    expanded: {
        maxHeight: '2000px'
    },
    collapsed: {
        maxHeight: 0,
        marginBottom: 0
    }
});
export function FeaturedAppsSection({ featuredAppsData, entityType, selectedLocale, embedHost, countryCode, showPrivateApps }, context) {
    const [isFeaturedAppsExpanded, setIsFeaturedAppsExpanded] = useState(true);
    const toggleFeaturedAppsSection = ()=>{
        setIsFeaturedAppsExpanded((prevState)=>!prevState);
    };
    if (featuredAppsData.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: featuredAppsStyles.section,
        "data-testid": "featured-apps-section",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: featuredAppsStyles.header,
                onClick: toggleFeaturedAppsSection,
                "data-testid": "featured-apps-header",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: featuredAppsStyles.title,
                        "data-testid": "featured-apps-title",
                        children: context.loc('CuratedType_FeaturedApps', 'Featured Apps')
                    }),
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: isFeaturedAppsExpanded ? 'ChevronDown' : 'ChevronRight',
                        className: featuredAppsStyles.chevron,
                        "data-testid": "featured-apps-chevron"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: `${featuredAppsStyles.content} ${isFeaturedAppsExpanded ? featuredAppsStyles.expanded : featuredAppsStyles.collapsed}`,
                "data-testid": "featured-apps-content",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "spza_filteredTileContainer",
                    children: featuredAppsData.map((entity, index)=>{
                        const entityRegistration = getEntityRegistration(entityType);
                        const TileType = entityRegistration.tileType;
                        return /*#__PURE__*/ _createElement(TileType, _object_spread_props(_object_spread({}, entity), {
                            item: entity,
                            key: entity.entityId,
                            tileIndex: index,
                            totalTiles: featuredAppsData.length,
                            selectedLocale: selectedLocale,
                            embedHost: embedHost,
                            countryContext: countryCode,
                            ribbonKey: 'FilteredGallery_FeaturedApps',
                            isPrivateOffer: showPrivateApps
                        }));
                    })
                })
            })
        ]
    });
}
FeaturedAppsSection.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
